import React, {
    useState,
    useEffect,
    useRef
} from 'react';

import SavedSearchBuilder from './SavedSearchBuilder.jsx';
import SavedSearchPreview from './SavedSearchPreview.jsx';

import RIQButton from '../../../../components/RIQButton.jsx';

import {
    useCurationConfigState,
    useCurationConfigValue,
    useSerializeConfigurations,
    useUpdateProps
} from '../../../../hooks/widgetConfiguration.js';


import RIQModal from '../../../../components/RIQModal.jsx';


function UnsavedWorkModal({onCompleteNavigation, onFinishMyWork}) {

    return (
        <RIQModal
            showModal={true}
        >
            <div
                className='tlw-overflow-x-auto tlw-p-25 tlw-text-center'
            >

                <div
                    className='tlw-mb-5 tlw-text-lg tlw-font-semibold'
                >
                    You didn&apos;t save your changes.
                </div>
                <p
                    className='tlw-mb-15'
                >
                    Are you sure you want to exit?
                </p>

                <RIQButton
                    className='tlw-mx-4 tlw-px-6 tlw-py-3'
                    onClick={onCompleteNavigation}
                >
                    Yes, exit
                </RIQButton>
                <RIQButton
                    className='tlw-mx-4 tlw-px-6 tlw-py-3'
                    onClick={onFinishMyWork}
                    variant='primary'
                >
                    No, finish my work
                </RIQButton>
            </div>
        </RIQModal>
    );
}

function cloneWizardProps(props) {
    return JSON.parse(JSON.stringify(props));
}

// NOTE we are writing our own equality function because we want to ignore
// values that would not survive serialization, specifially, object keys with
// `undefined` values that don't exist on their counterpart
function isEqualProps(a, b) {
    if (_.isObject(a)) {
        return _.every(a, (value, key) => {
            if (_.isUndefined(value)) {
                return (!_.has(b, key) || _.isUndefined(b[key]));
            }
            return (_.has(b, key) && isEqualProps(value, b[key]));
        });
    }

    return _.isEqual(a, b);
}

function ReturnToInstantSearch() {

    const [showAdvancedSearchEditor, setShowAdvancedSearchEditor] = useCurationConfigState('showAdvancedSearchEditor');

    const [showConfirmExitModal, setShowConfirmExitModal] = useState(false);

    const updateProps = useUpdateProps(null, {
        force: true
    });

    const originalProps = useRef({});

    const saveProps = useSerializeConfigurations(allProps => {
        originalProps.current = cloneWizardProps(allProps);
    }, [showAdvancedSearchEditor]);

    useEffect(() => {
        if (showAdvancedSearchEditor) {
            saveProps();
        }

    }, [saveProps, showAdvancedSearchEditor]);

    function completeBackClick() {
        // This is necessary as even though the props aren't persisted to the url, they're still in the in-memory recoil state.
        updateProps(originalProps.current);
        setShowAdvancedSearchEditor(false);
    }

    const onBackClick = useSerializeConfigurations(allProps => {
        if (!isEqualProps(allProps, originalProps.current)) {
            setShowConfirmExitModal(true);
        } else {
            completeBackClick();
        }
    });

    return (
        <>
            <RIQButton
                className='tlw-mb-10 !tlw-border-none !tlw-bg-transparent tlw-px-2.5 tlw-py-0.5 tlw-text-md tlw-leading-normal tlw-text-blue-400 !tlw-shadow-none hover_tlw-bg-transparent hover_tlw-underline focus_tlw-bg-transparent active_tlw-bg-transparent'
                onClick={onBackClick}
            >
                <span className='fa fa-chevron-left'/>
                &nbsp;Return to Instant Search results
            </RIQButton>

            {showConfirmExitModal &&
                <UnsavedWorkModal
                    onCompleteNavigation={completeBackClick}
                    onFinishMyWork={() => setShowConfirmExitModal(false)}
                />
            }
        </>
    );
}


export default function SearchWizard({isEditingInstantSearch, isSampleTopic}) {

    const [isSourceInvalid, setIsSourceInvalid] = useState(false);

    const searchTerms = useCurationConfigValue('searchTerms');
    const hasInitialSearchTerms = useRef(!_.isEmpty(searchTerms));
    const isNewInstantSearch = isEditingInstantSearch && !hasInitialSearchTerms.current;

    return (
        <>
            {isEditingInstantSearch &&
            !isNewInstantSearch &&
                <ReturnToInstantSearch
                />
            }
            <div
                className='tlw-grid tlw-grid-cols-1 sm_tlw-grid-cols-12 sm_tlw-gap-10'
            >
                <div
                    className='tlw-relative tlw-col-span-1 sm_tlw-col-span-7'
                >
                    <SavedSearchBuilder
                        isSourceInvalid={isSourceInvalid}
                        setIsSourceInvalid={setIsSourceInvalid}
                        isEditingInstantSearch={isEditingInstantSearch}
                        isNewInstantSearch={isNewInstantSearch}
                    />
                </div>

                <div
                    className='tlw-relative tlw-col-span-1 sm_tlw-col-span-5'
                >
                    <SavedSearchPreview
                        instanceId='saved-search-preview'
                        isSampleTopic={isSampleTopic}
                        isSourceInvalid={isSourceInvalid}
                    />
                </div>
            </div>
        </>
    );
}
